export default defineNuxtPlugin(() => {
  if (process.server) return

  let userId = 'not login'
  try {
    const { user } = useAuth()
    userId = user.value?.id || user.value?.uid || 'not login'
  } catch {
    // auth not ready yet; keep default
  }

  if (window._paq) {
    window._paq.push(['setUserId', userId])
  }
})
